import { Col, Row } from '@advanza/grid'
import { Divider } from '@advanza/ui'
import { saveReview } from 'actions/reviews'
import EntityComponent from 'components/services/EntityComponent'
import EntityComponentContainer from 'containers/EntityComponentContainer'
import React from 'react'
import ReviewStars from './ReviewStars'

interface ReviewEntityState {
    name?: string
    rating?: number
    body?: string
    created?: string
    status?: number
    _isTouched?: boolean
    _saving?: boolean
    _errors?: Record<string, unknown>
    _beforeSave?: Record<string, unknown>
    [key: string]: unknown
}

export interface ReviewEntityProps {
    entity?: ReviewEntityState
    entityId?: string
    entityKey?: string
    entities?: Record<string, unknown>
    changeEntity: (diff: Record<string, unknown>, options?: Record<string, unknown>) => void
    changeOtherEntity: (options: Record<string, unknown>) => void
    save: (params?: unknown) => Promise<unknown>
    delete?: (params?: unknown) => Promise<unknown>
}

class ReviewEntity extends EntityComponent {
    addCtlEnterSave = {
        onKeyDown: (e: React.KeyboardEvent) =>
            e.ctrlKey && e.key === 'Enter' && this.save().catch(() => {}),
    }

    editFields(): Record<
        string,
        Record<string, unknown> & {
            options?: Array<{ value: number; title: React.ReactNode }>
            dayPickerProps?: { disabled: (date: Date) => boolean }
        }
    > {
        const five = [2, 4, 6, 8, 10]
        return {
            name: { type: 'text', msg: 'Name', ...this.addCtlEnterSave },
            rating: {
                type: 'select',
                placeholder: 'Rating',
                className: 'select-stealth select-wide select-min',
                options: five.map((nr) => ({
                    value: nr,
                    title: <ReviewStars avg={nr / 2} showOnlyStars />,
                })),
            },
            body: {
                type: 'textArea',
                msgid: 'Review body',
                style: {
                    backgroundColor: '#fff',
                    padding: 5,
                    border: '1px solid #b6b9cd',
                    borderRadius: 4,
                },
                ...this.addCtlEnterSave,
            },
            created: {
                type: 'date',
                msg: 'Created',
                format: 'dd-MM-yyyy',
                dayPickerProps: {
                    disabled: (date: Date) => date > new Date(),
                },
            },
            status: {
                type: 'select',
                className: 'select-min select-stealth',
                options: [
                    { title: 'Accepted', value: 1 },
                    { title: 'Deleted', value: 0 },
                    { title: 'Not validated', value: 3 },
                ],
            },
        }
    }

    render(): React.ReactNode {
        const { entity } = this.props as ReviewEntityProps
        const isTouched = entity?._isTouched
        const saving = entity?._saving

        return (
            <div>
                <Row>
                    <Col x>{this.renderInput('name')}</Col>
                    <Col x>{this.renderInput('rating')}</Col>
                </Row>

                {this.renderInput('body')}
                <Divider />

                <Row>
                    <Col x>{this.renderInput('status')}</Col>
                    <Col x>{this.renderInput('created')}</Col>
                </Row>

                <Row>
                    <Col x>
                        <button
                            type="button"
                            onClick={() => this.save().catch(() => {})}
                            disabled={!isTouched}
                            className="btn cta to-right">
                            {saving ? 'saving..' : 'Save'}
                        </button>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default EntityComponentContainer(ReviewEntity, {
    store: 'reviews',
    name: 'reviews',
    saveFunc: saveReview,
})
